import { paginatedGql, toStandardResult } from "../util/graphql.js";
import { useMutation, useQuery } from "@apollo/react-hooks";

import gql from "graphql-tag";

const trainingVoucherSchema = `
  id
  voucherCode
  companyCode
  amount
  expirationDate
  reference
  used
  usedAt
`;

export function useTrainingVoucherCreate() {
  const [mutation, result] = useMutation(
    gql`
      mutation SEND_TRAINING_VOUCHER_CREATE($amount: Float!, $data: TrainingVoucherDataPrivateInput) {
        private {
          trainings {
            success: createTrainingVoucher(amount: $amount, data: $data) {
              ${trainingVoucherSchema}
            }
          }
        }
      }
    `,
  );
  return [
    ({ amount, reference, date, ...data }) =>
      mutation({
        variables: {
          amount,
          data: {
            ...data,
            reference: [reference, date].filter(Boolean).join(" - "),
          },
        },
      }),
    ...toStandardResult(result, "private.trainings.success"),
  ];
}

export function useTrainingVouchers(filter, pagination) {
  const result = useQuery(
    gql`
      query GET_TRAINING_VOUCHERS($filter: TrainingVoucherPrivateFilterInput, $pagination: PaginationInput) {
        private {
          trainings {
            trainingVouchers: findTrainingVouchers(
              filter: $filter
              pagination: $pagination
            ) {
              ${paginatedGql(trainingVoucherSchema)}
            }
          }
        }
      }
    `,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        filter,
        pagination,
      },
    },
  );

  return toStandardResult(result, "private.trainings.trainingVouchers");
}
